module.exports = __webpack_public_path__ + "static/media/supply-overview.1e82795d.jpg";